import { usersAPI } from "@/api";
import { setWorkingHoursSelectedEmployees, setWorkingHoursSelectedEmployeesLoading, setWorkingHoursSelectedEmployeesError } from "./timetableSlice";
import store from "@store/redux.store";
import rolesEnum from "@/constant/rolesEnum";

export const fetchWorkingHoursSelectedEmployees = () => async (dispatch, getState) => {
  dispatch(setWorkingHoursSelectedEmployeesLoading(true))
  const { filters } = getState().timetable;
  const idsEmployees = !!filters?.seminariansInCourses?.length ? filters?.seminariansInCourses : filters?.seminarians;
  if(
      store.getState()?.profile?.profile?.role === rolesEnum.children || 
      store.getState()?.profile?.profile?.role === rolesEnum.parent ||
      !idsEmployees?.length
    ){
    setWorkingHoursSelectedEmployees({})
    return;
  }
  const idsEmployeesJson = JSON.stringify(idsEmployees);
  
  try {
    const params = { 
      idsEmployees: idsEmployeesJson,
    }
    const response = await usersAPI.getWorkingHoursEmployees(params);
    console.log(response)
    if(response.data.data){
      dispatch(setWorkingHoursSelectedEmployees(response.data.data));
      dispatch(setWorkingHoursSelectedEmployeesError(null))
    }
    else{
      dispatch(setWorkingHoursSelectedEmployees({}))
      dispatch(setWorkingHoursSelectedEmployeesError('Ошибка'))
    }
  } catch (error) {
    dispatch(setWorkingHoursSelectedEmployees({}))
    dispatch(setWorkingHoursSelectedEmployeesError(error))
  } finally {
    dispatch(setWorkingHoursSelectedEmployeesLoading(false))
  }
};